import React, { useContext } from "react";
import { Tooltip, IconButton, FormControl, FormLabel, RadioGroup, FormControlLabel, Radio } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import GroupBDRBiologists from "../FieldTags/GroupBDRBiologists";
import { UserContext } from "../../context/UserContext";
import pullListLabels from "../../util/PullListLabels";
import ROLES from "../../util/roles";
import HistoryLogElement from "./HistoryLogElement";
import { checkRole } from "../../util/FormUtils";

const DispositionOfSample = ({ dispositionOfSample, handleChange, pullLists, required }) => {
    const { user } = useContext(UserContext);
    const canEdit = checkRole(user, [ROLES.BIOLOGIST, ROLES.BIOOPS, ROLES.APPROVER]);

    return (
        <div id="dispositionOfSample" className="planField">
            <GroupBDRBiologists />
            <FormControl required={required}>
                <div style={{ display: "flex", alignItems: "center" }}>
                    <FormLabel className="planRadioTitle" style={{ marginRight: 4 }}>
                        {pullListLabels.dispositionOfSample}
                    </FormLabel>
                    <Tooltip
                        placement="right"
                        title={
                            <>
                                <div>In general, we recommend:</div>
                                <ul style={{ paddingLeft: "1.2em", margin: 0 }}>
                                    <li><em>Disposed in Lab</em>  for Serum, Plasma, and RNA</li>
                                    <li><em>Returned to Repository</em>  for DNA, Biopsy, and Stool</li>
                                </ul>
                            </>
                        }
                    >
                        <IconButton size="small" aria-label="info">
                            <InfoOutlinedIcon fontSize="small" />
                        </IconButton>
                    </Tooltip>
                </div>
                <RadioGroup
                    name="dispositionOfSample"
                    label={pullListLabels.dispositionOfSample}
                    value={dispositionOfSample}
                    onChange={(e) => handleChange("dispositionOfSample", e.target.value)}
                    row
                >
                    <>
                        <FormControlLabel
                            value="Disposed in Lab"
                            control={<Radio disabled={!canEdit} />}
                            label="Disposed in Lab"
                        />
                        <FormControlLabel
                            value="Returned to Repository"
                            control={<Radio disabled={!canEdit} />}
                            label="Returned to Repository"
                        />
                    </>
                </RadioGroup>
            </FormControl>
            <HistoryLogElement pullLists={pullLists} label={"dispositionOfSample"} />
        </div>
    );
};

export default DispositionOfSample;